import {
  CSSResultGroup,
  SVGTemplateResult,
  TemplateResult,
  html,
  svg,
} from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import componentStyles from './se-logo.css.lit';
import logoBgLight from '../../../assets/svg/logo/logoBgLight';
import logoBgDark from '../../../assets/svg/logo/logoBgDark';

export const seLogoVariants = ['light', 'dark'] as const;

export type SeLogoVariant = typeof seLogoVariants[number];

/**
 * The SeLogo component
 * @element se-logo
 */
@customElement('se-logo')
export class SeLogo extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * sets the logo to light or dark background version.
   */
  @property({ type: String })
  variant: SeLogoVariant;

  /**
   * if true logo will not be wrapped in an <a> linking back to the homepage.
   */
  @property({ type: Boolean })
  isDecorative: boolean;

  logoAlt(): SVGTemplateResult {
    return svg`${unsafeSVG(logoBgLight)}`;
  }

  logo(): SVGTemplateResult {
    return svg`${unsafeSVG(logoBgDark)}`;
  }

  logoTemplate() {
    if (this.variant === 'light') {
      return html`<div class="se-logo">${this.logoAlt()}</div>`;
    } else {
      return html`<div class="se-logo">${this.logo()}</div>`;
    }
  }

  render(): TemplateResult {
    return html`
      ${!this.isDecorative
        ? html` <a aria-label="Homepage" href="/"> ${this.logoTemplate()} </a> `
        : html`${this.logoTemplate()}`}
    `;
  }
}
